import React from 'react'
import { string, array } from 'prop-types'

import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'

import styles from './BrandNumbers.module.scss'

const BrandNumbers = ({ statistics }) => {
  return (
    <div className={styles.BrandNumbers}>
      <Container className={styles.BrandNumbersContainer} gutter center>
        <Type
          themed
          as="h2"
          size={['heading3', 'heading0']}
          weight="medium"
          className={styles.Title}
        >
          How our numbers stack up
        </Type>
        <div className={styles.Numbers}>
          {statistics?.length &&
            statistics.map((stat, i) => (
              <Number
                label={stat.label}
                value={stat.statistic}
                key={`BrandNumbers--Statistic--${i}`}
              />
            ))}
        </div>
      </Container>
    </div>
  )
}

BrandNumbers.propTypes = {
  statistics: array.isRequired
}

export default BrandNumbers

const Number = ({ value, label }) => (
  <div className={styles.NumberWrapper}>
    <div className={styles.Number}>
      <Type themed size={['heading3', 'display0']} weight="bold">
        {value}
      </Type>
    </div>
    <Type size="body2" weight="medium" className={styles.Label}>
      {label}
    </Type>
  </div>
)

Number.propTypes = {
  value: string.isRequired,
  label: string.isRequired
}
